
(() => {
 const setup = () => {
  const dialog = document.querySelector('[data-nds-search]');
  document.querySelectorAll('[data-nds-search-open]').forEach(button => button.onclick = () => { if(dialog){dialog.showModal();dialog.querySelector('input[type="search"]')?.focus();} });
  document.querySelectorAll('[data-nds-search-close]').forEach(button => button.onclick = () => dialog?.close());
  if(dialog) dialog.onclick = event => { if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();} };
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
   document.documentElement.classList.add('nds-js');
   const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting){entry.target.classList.add('nds-is-visible');observer.unobserve(entry.target);} }), { threshold:.08 });
   document.querySelectorAll('.nds-section-heading,.nds-collection-card,.nds-product-card,.nds-maker-copy').forEach(element=>{element.classList.add('nds-reveal');observer.observe(element);});
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
 document.addEventListener('submit',event=>{
  if(!event.target.matches('form[action*="/cart/add"]'))return;
  const field=document.querySelector('input[name="properties[Graduation Year]"]');
  if(field && !field.value.trim()){event.preventDefault();event.stopImmediatePropagation();field.required=true;field.reportValidity();field.focus();}
 },true);
})();
